import { useMutation } from '@tanstack/react-query';
import { submitWaitlistEmail } from './waitlistApi';
import type { WaitlistRequest, WaitlistResponse } from '../../../shared/api/types';

/**
 * Хук для отправки email в waitlist
 */
export const useWaitlistMutation = () => {
  return useMutation<WaitlistResponse, Error, WaitlistRequest>({
    mutationFn: submitWaitlistEmail,
  });
};
